import type { Pinia } from 'pinia'
import { store } from '@/store'
import type { SdkExternalContext } from '@/microfrontends/monitor-mfe/sdk/apply-store-context'

export interface MountMonitorOptions {
  el: string | HTMLElement
  initialQuery?: Record<string, string | string[]>
  context?: SdkExternalContext
}

function readLocalStorage (key: string): string {
  try {
    return localStorage.getItem(key) || ''
  } catch {
    return ''
  }
}

/** 主站由 left-header 写入 localStorage，SDK 需同步到 organizationData 才能拉机场列表 */
export function hydrateOrganizationFromStorage (pinia: Pinia, ctx?: SdkExternalContext): void {
  const info = store.informationListStore.informationStore(pinia)
  const org = {
    ...info.organizationData,
    ...(ctx?.organizationData || {}),
  }

  if (!org.cityCode) org.cityCode = readLocalStorage('cityCode')
  if (!org.areaCode) org.areaCode = readLocalStorage('areaCode')
  if (!org.provinceCode) org.provinceCode = readLocalStorage('provinceCode')

  if (org.cityCode || org.areaCode || org.provinceCode) {
    void info.setOrganizationData(org)
  }
}

/** left-monitor 机场/无人机状态区依赖 osdVisible + WebSocket deviceState */
export function initOsdVisibleFromContext (pinia: Pinia, ctx?: SdkExternalContext): void {
  const my = store.other.useMyStore(pinia)
  const info = store.informationListStore.informationStore(pinia)
  const uav = (ctx?.uavObj ?? info.uavObj) as Record<string, unknown> | undefined
  const dockSn =
    ctx?.dockSn ||
    info.airNumberValue ||
    (uav?.deviceSn as string | undefined) ||
    (uav?.gatewaySn as string | undefined)
  const childSn = (uav?.childSn as string | undefined) || ''

  if (!dockSn && !(ctx?.osdVisible && Object.keys(ctx.osdVisible).length)) return

  my.$patch((s) => {
    if (ctx?.osdVisible) Object.assign(s.osdVisible, ctx.osdVisible)
    if (dockSn) {
      s.osdVisible.gateway_sn = dockSn
      s.osdVisible.visible = true
      s.osdVisible.dockControlPanelVisible = false
      if (uav?.nickName) s.osdVisible.gateway_callsign = String(uav.nickName)
    }
    if (childSn) s.osdVisible.sn = childSn
  })
}

export function normalizeLeftMonitorMountOptions (options: MountMonitorOptions): MountMonitorOptions {
  const ctx = options.context
  const uav = ctx?.uavObj as Record<string, unknown> | undefined
  const dockSn = ctx?.dockSn || (uav?.deviceSn as string | undefined) || (uav?.gatewaySn as string | undefined)
  const initialQuery = { ...(options.initialQuery || {}) }

  if (!initialQuery.deviceSn && dockSn) {
    initialQuery.deviceSn = String(dockSn)
  }

  return {
    ...options,
    initialQuery: Object.keys(initialQuery).length ? initialQuery : options.initialQuery,
  }
}
